import Vue from 'vue'
import Main from './main.vue'
import * as PopupManagement from '../../../src/util/popupManagement.js'

let DialogConstructor = Vue.extend(Main);
let instance = null;
let instances = [];
let count = 1;

const config = {
    type: '',
    title: '',
    message: '',
    showCancelButton: false,
    cancelButtonText: '取消',
    icon: '',
    confirmButtonText: '确认',
    layer: false,
    iconClass: '',
};

const Dialog = function(options = {}) {
    return new Promise((resolve, reject)=> {
        if(typeof options === 'string') {
            options = Object.assign({}, config, {
                message: options,
            })
        }
        else {
            options = Object.assign({}, config, options)
        }

        if(typeof Promise !== 'undefined') {
            options.confirm = resolve
            options.cancel = reject
        }
        
    
        instance = new DialogConstructor({
            propsData: options
        })
        instance.vm = instance.$mount()
        instance.dom = instance.vm.$el
        instance.dom.style.zIndex = PopupManagement.nextZIndex()
        instance.id = count++
        document.body.appendChild(instance.dom)
        instance.vm.visible = true
        instances.push(instance)
    })
};

Dialog.confirm = function(options) {
    options = Object.assign({}, config, options, { type: 'confirm' })
    return Dialog(options);
}

Dialog._prompt = function(options) {
    options = Object.assign({}, config, options, { type: 'prompt' })
    return Dialog(options);
}

Dialog.close = function(id) {
    let index = instances.findIndex(v=> v.id === id);
    if(index !== -1) {
        instances[index].vm.close()
        instances.splice(index, 1)
    }
}

Dialog.closeAll = function() {
    for(let i = 0, len = instances.length; i < len; i++) {
        Dialog.close(instances[i].id)
    }
}

export default Dialog;